import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import OfflineIndicator from "@/components/OfflineIndicator";
import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import AdminLayout from "@/layouts/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Teachers from "@/pages/admin/Teachers";
import Students from "@/pages/admin/Students";
import StudentDetail from "@/pages/admin/StudentDetail";
import TeacherLayout from "@/layouts/TeacherLayout";
import MyStudents from "@/pages/teacher/MyStudents";
import StudentProfile from "@/pages/teacher/StudentProfile";
import ClockInOut from "@/pages/teacher/ClockInOut";
import TimeEntries from "@/pages/admin/TimeEntries";
import Points from "@/pages/admin/Points";
import AllRecords from "@/pages/admin/AllRecords";
import Exports from "@/pages/admin/Exports";
import Semesters from "@/pages/admin/Semesters";
import ImportData from "@/pages/admin/ImportData";
import AdminAttendance from "@/pages/admin/Attendance";
import TeacherAttendance from "@/pages/teacher/Attendance";

function RootRedirect() {
  const { user } = useAuth();
  if (user === undefined) return null;
  if (user === null) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/change-password" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/teacher"} replace />;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user) {
    if (user.must_change_password) return <Navigate to="/change-password" replace />;
    return <Navigate to={user.role === "admin" ? "/admin" : "/teacher"} replace />;
  }
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<LoginRoute />} />
            <Route
              path="/change-password"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute role="admin">
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="teachers" element={<Teachers />} />
              <Route path="students" element={<Students />} />
              <Route path="students/:id" element={<StudentDetail />} />
              <Route path="attendance" element={<AdminAttendance />} />
              <Route path="semesters" element={<Semesters />} />
              <Route path="import" element={<ImportData />} />
              <Route path="records" element={<AllRecords />} />
              <Route path="time-entries" element={<TimeEntries />} />
              <Route path="points" element={<Points />} />
              <Route path="exports" element={<Exports />} />
            </Route>
            <Route
              path="/teacher"
              element={
                <ProtectedRoute role="teacher">
                  <TeacherLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<MyStudents />} />
              <Route path="attendance" element={<TeacherAttendance />} />
              <Route path="students/:id" element={<StudentProfile />} />
              <Route path="clock" element={<ClockInOut />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster />
          <OfflineIndicator />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
